import { jsonGet } from '../components/ajax';
let cboxOptions = {
  maxWidthLg: '513px',
  maxHeightLg: '585px',
  maxWidthMd: '513px',
  maxHeightMd: '585px',
  maxWidthSm: '360px',
  maxHeightSm: '596px'
};
let emailResentActiveLink;
let mainContainerClass;
const emailNotification = {
  checkWidth() {
    if (window.innerWidth >= 1368) {
      return cboxOptions.maxWidthLg;
    } else if (window.innerWidth >= 768 && window.innerWidth < 1368) {
      return cboxOptions.maxWidthMd;
    } else {
      return cboxOptions.maxWidthSm;
    }
  },
  checkHeight() {
    if (window.innerHeight >= 1368) {
      return cboxOptions.maxHeightLg;
    } else if (window.innerHeight >= 768 && window.innerHeight < 1368) {
      return cboxOptions.maxHeightMd;
    } else {
      return cboxOptions.maxHeightSm;
    }
  },
  displayNotificatioOverlay() {
    if ($('#showOktaTokenNotification').val() === 'true') {
      ACC.colorbox.open('', {
        escKey: false,
        overlayClose: false,
        closeButton: false,
        html: $('#email-notification-overlay').html(),
        onLoad: $('#cboxOverlay').css('position', 'fixed'),
        width: emailNotification.checkWidth(),
        height: emailNotification.checkHeight(),
        className: 'email-notification-overlay-main'
      });
    } else if ($('#showOktaTokenExpire').val() === 'true') {
      ACC.colorbox.open('', {
        escKey: false,
        overlayClose: false,
        closeButton: false,
        html: $('#exp-email-notification-overlay').html(),
        onLoad: $('#cboxOverlay').css('position', 'fixed'),
        width: emailNotification.checkWidth(),
        height: emailNotification.checkHeight(),
        className: 'exp-email-notification-overlay-main'
      });
         //startCountDown();
      emailResentActiveLink = $('#showOktaTokenExpire').attr('data-url');
      mainContainerClass = $('.exp-email-notification-overlay-container:last');
    }
  },
  resendEmailNotification() {
    startCountDown();
    jsonGet(emailResentActiveLink+'&activationEmailSentTime='+new Date().toLocaleString()).then(response => {
      if (response === true || response === 'true') {
        $(this)
          .parents('#cboxLoadedContent')
          .find('.resent-email-success-msg')
          .removeClass('hidden');
        mainContainerClass.scrollTop(
          mainContainerClass.find('.resent-email-success-msg').offset().top
        );
      } else if (response.toLowerCase() === 'failure') {
        window.location.href = '/';
      }
    });
  },
  init() {
    this.displayNotificatioOverlay();
    $(document).on(
      'click',
      '.exp-notification-overlay-btn',
      emailNotification.resendEmailNotification
    );
  }
};
$(document).ready(function() {
  emailNotification.init();
});

function startCountDown(){
  var button= $('#colorbox').find('#resendEmailActivationBtn');
  button.attr('disabled', true);
  var countDownDuration = 29;
  var countDown = setInterval(function(){
    countDownDuration--;
    if(countDownDuration == 0){
      button.attr('disabled', false);
      clearInterval(countDown);
    }
  },1000);
}

export default emailNotification;
